import {IComponentOptions} from 'angular';
import {IStateService} from 'angular-ui-router';
import ErrorService from '../../../core/errors/service/ErrorService';
import BenutzerRS from '../../../core/service/BenutzerRS.rest';
import PasswordStrengthService from '../../../core/service/PasswordStrengthService';
import {getLanguageByKey, TSSprache} from '../../../models/enums/TSSprache';
import TSBenutzer from '../../../models/TSBenutzer';
import TSPasswordData from '../../../models/TSPasswordData';
import {IChangePasswordParams} from '../../authentication.route';
import IFormController = angular.IFormController;
import ILocationService = angular.ILocationService;
import ILogService = angular.ILogService;
import ITimeoutService = angular.ITimeoutService;
import ITranslateService = angular.translate.ITranslateService;

let template = require('./invitedUserProfileView.html');

export class InvitedUserProfileComponentConfig implements IComponentOptions {
    transclude = false;
    template = template;
    controller = InvitedUserProfileViewController;
    controllerAs = 'vm';
}

/**
 * this component allows to edit userprofile data without through a token link
 */
export class InvitedUserProfileViewController {

    static $inject: string[] = ['$state', '$stateParams', 'BenutzerRS',
        '$location', '$log', 'ErrorService', 'CONSTANTS', '$translate', '$timeout', 'PasswordStrengthService'];

    private model: TSPasswordData;
    private form: IFormController;
    private benutzerToEdit: TSBenutzer;

    constructor(private $state: IStateService, private $stateParams: IChangePasswordParams,
                private benutzerRS: BenutzerRS, private $location: ILocationService,
                private $log: ILogService, private errorService: ErrorService, private CONSTANTS: any,
                private $translate: ITranslateService, private $timeout: ITimeoutService,
                private passwordStrengthService: PasswordStrengthService) {

    }

    $onInit() {
        this.errorService.clearAll();
        let email: string = '';
        if (this.$stateParams.email) {
            email = decodeURIComponent(this.$stateParams.email);
        }
        let token = this.$stateParams.changetoken || '';
        this.model = new TSPasswordData(email, token);

        let lang: TSSprache = TSSprache.DEUTSCH;
        if (this.$stateParams.lang) {

            lang = getLanguageByKey(decodeURIComponent(this.$stateParams.lang));
        }

        //aus sicherheitsgruenden lesen wir hier den user der zu dem token gehoert NICHT aus der db

        this.benutzerToEdit = this.initEmptyBenutzerWithToken(email, token, lang);

    }

    private initEmptyBenutzerWithToken(email: string, token: string, lang: TSSprache): TSBenutzer {
        let createdBenutzer = new TSBenutzer();
        createdBenutzer.passwordData = new TSPasswordData(email, token);
        createdBenutzer.korrespondenzsprache = lang;
        return createdBenutzer;
    }

}



// WEBPACK FOOTER //
// ./src/app/authentication/component/invitedUserProfileView/invitedUserProfileView.ts